"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.expiry = exports.cvv = exports.cardNumber = void 0;
var asg_1 = require("@alinta-digital/asg");
exports.cardNumber = {
    options: {
        brands: ['visa', 'mastercard', 'amex'],
        placeholder: 'Card number',
        style: {
            base: {
                fontSize: '16px',
                fontWeight: '200',
                color: asg_1.colors.primaryText
            }
        }
    },
    elementId: 'card-number'
};
exports.cvv = {
    options: {
        placeholder: 'CVV',
        style: {
            base: {
                fontSize: '16px',
                fontWeight: '200',
                color: asg_1.colors.primaryText
            }
        }
    },
    elementId: 'card-cvv'
};
exports.expiry = {
    options: {
        placeholder: 'MM / YY',
        style: {
            base: {
                fontSize: '16px',
                fontWeight: '200',
                color: asg_1.colors.primaryText
            }
        }
    },
    elementId: 'card-expiry'
};
//# sourceMappingURL=config.js.map